export default __webpack_public_path__ + "static/media/rejectPlanIcon.9b187240.svg";